// pages/FormViewerPage/sections/FormViewerStyles.tsx — Inline style khusus form
import React from 'react';

export const FormViewerStyles: React.FC<{ isSimpleEmbed?: boolean; isSeamless?: boolean }> = ({ isSimpleEmbed, isSeamless }) => (
    <>
        <style dangerouslySetInnerHTML={{ __html: '.animate-buttonShine { background: linear-gradient(90deg,#4f46e5 0%,#6366f1 25%,#818cf8 50%,#6366f1 75%,#4f46e5 100%); background-size: 200% 100%; animation: buttonShine 3s linear infinite; }' }} />
        {(isSimpleEmbed || isSeamless) && (
            <style dangerouslySetInnerHTML={{ __html: 'html, body, #root { margin: 0 !important; padding: 0 !important; min-height: 0 !important; height: auto !important; background: transparent !important; overflow: hidden !important; }' }} />
        )}
    </>
);
